export const userRegister = {
  register: {
    confirmPassword: {
      action: 'Confirmer le mot de passe',
      label: 'Confirmer le mot de passe',
      placeholder: 'Confirmer le mot de passe',
    },
    managementInMyAccount: 'Gestion dans Mon compte.',
    termsAndConditions: 'Modalités et conditions',
    signIn: "J'ai déjà un compte. Se connecter",
    register: "S'inscrire",
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    resetPassword: 'Réinitialiser le mot de passe',
    createAccount: 'Créer un compte',
    title: 'Titre',
    firstName: {
      label: 'Prénom',
      placeholder: 'Prénom',
    },
    lastName: {
      label: 'Nom de famille',
      placeholder: 'Nom de famille',
    },
    emailAddress: {
      label: 'Adresse courriel',
      placeholder: 'Adresse courriel',
      invalidFormat: 'Format de courriel invalide. Veuillez utiliser le format: nom@compagnie.com',
    },
    confEmailAddress: {
      label: "Confirmer l'adresse courriel",
      placeholder: "Confirmer l'adresse courriel",
    },
    accountNumber: {
      label: 'Numéro de compte',
      placeholder: 'Numéro de compte',
    },
    jobFunction: {
      label: 'Fonction',
      placeholder: 'Fonction',
    },
    contactNumber: {
      label: 'Numéro de téléphone',
      placeholder: 'Numéro de téléphone',
      invalidFormat: 'Format de téléphone invalide. Veuillez utiliser le format: (XXX) XXX-XXXX',
    },
    password: {
      label: 'Mot de passe',
      placeholder: 'Mot de passe',
    },
    titleField: {
      label: 'Titre',
      placeholder: 'Entrer le titre',
    },
    newPassword: 'Nouveau mot de passe',
    emailMarketing:
      'Utiliser mes données personnelles pour recevoir des bulletins électroniques de campagnes marketing. Pour modifier vos paramètres, accédez à Gestion du consentement dans Mon compte.',
    confirmThatRead: 'Je confirme avoir lu et accepté les',
    selectTitle: 'Sélectionner le titre',
    passwordMinRequirements:
      'Le mot de passe doit comporter au moins six caractères, avec une majuscule, un chiffre et un symbole',
    bothPasswordMustMatch: 'Les deux mots de passe doivent correspondre',
    titleRequired: 'Le titre est obligatoire.',
    postRegisterMessage: 'Veuillez vous connecter avec les informations fournies.',
    pageHeader1: "Nouvelle demande d'utilisateur",
    userInformation: 'Informations utilisateur',
    address: {
      label: 'Adresse',
      placeholder: "Entrer l'adresse",
    },
    city: {
      label: 'Ville',
      placeholder: 'Entrer la ville',
    },
    country: {
      label: 'Pays',
      placeholder: 'Sélectionner le pays',
    },
    state: {
      label: 'État/Province',
      placeholder: "Sélectionner l\'état/la province"
    },
    zipCode: {
      label: 'Code postal/Code ZIP',
      placeholder: 'Entrer le code postal/code ZIP',
    },
    languagePreference: {
      label: 'Préférence de langue',
      placeholder: 'Sélectionner la langue',
    },
    accountInformation: 'Informations du compte',
    customerType: {
      label: 'Type de client',
      placeholder: 'Sélectionner le type de client',
    },
    employeeId: {
      label: "ID d'employé",
      placeholder: "Entrer l'ID d'employé",
    },
    soldToAccounts: 'Comptes vendus à',
    soldToAccountNumber: {
      label: 'No de compte vendu à (No de compte agent)',
      placeholder: 'Entrer le numéro de compte',
    },
    companyName: {
      label: "Nom de l'entreprise",
      placeholder: "Entrer le nom de l'entreprise",
    },
    addressLine1: {
      label: 'Adresse ligne 1 vendu à',
      placeholder: "Entrer l'adresse ligne 1",
    },
    addressLine2: {
      label: 'Adresse ligne 2 vendu à',
      placeholder: "Entrer l'adresse ligne 2",
    },
    soldToCity: {
      label: 'Ville vendu à',
      placeholder: 'Entrer la ville',
    },
    soldToCountry: {
      label: 'Pays vendu à',
      placeholder: 'Sélectionner le pays',
    },
    soldToZipCode: {
      label: 'Code postal/Code ZIP vendu à',
      placeholder: 'Entrer le code postal/code ZIP',
    },
    soldToState: {
      label: 'État/Province vendu à',
      placeholder: 'Sélectionner l\'état/la province',
    },
    deleteAccount: 'Supprimer le compte',
    addMoreSoldToAccounts: "Ajouter d'autres comptes vendus à pour cette division",
    removeSoldToAccountEntry: "Supprimer l'entrée de compte vendu à",
    captcha: {
      label: 'Vérification',
      required: "Veuillez vérifier que vous n'êtes pas un robot",
    },
  },
};
